import React, { useEffect, useState } from "react";
import { getForumTopicsActionHandler } from "../../../../store/actions/actionHandlers/socialActionHandler";
import classes from "./ForumTopics.module.scss";
import { useDispatch, useSelector } from "react-redux";
import InfiniteScrollComponent from "../../../../components/Common/InfiniteScroll/InfiniteScrollComponent";
import noTopicImage from "../../../../assets/images/SocialIcons/no_topic.png";
import EditIcon from "../../../../components/Common/SvgIcons/TableIcons/EditIcon";
import {
  setEditForumTopicResponse,
  setForumTopics,
} from "../../../../store/actions/actionCreators/socialActionCreator";
import Loader from "../../../../components/Common/Loader/Loader";
import { FormattedMessage } from "react-intl";

const ForumTopics = ({
  handleForumClick,
  setCreateForumTopicModal,
  selectedTopic,
  setSelectedThread,
}) => {
  const pageSize = 10;
  const dispatch = useDispatch();
  const socialState = useSelector((state) => state.socialReducer);
  const {
    createForumTopicResponseData,
    editForumTopicResponseData,
    forumTopics,
  } = socialState;
  const [hasMoreData, setHasMoreData] = useState(true);
  const [totalRows, settotalRows] = useState(0);
  const [pageNum, setpageNum] = useState(1);
  const [forumTopicsData, setforumTopicsData] = useState(null);
  const [selectedTopicId, setselectedTopicId] = useState(null);
  const [firstTime, setFirstTime] = useState(true);
  const [topicLoader, setTopicLoader] = useState(true);

  useEffect(() => {
    if (forumTopics && firstTime) {
      setFirstTime(false);
      handleForumClick(forumTopics?.[0]);
      setselectedTopicId(forumTopics?.[0]?.Id);
    }
  }, [forumTopics, handleForumClick, dispatch, firstTime]);

  useEffect(() => {
    dispatch(setForumTopics(forumTopics));
  }, [forumTopics, dispatch]);

  useEffect(() => {
    if (createForumTopicResponseData) {
      dispatch(
        getForumTopicsActionHandler(
          1,
          pageSize,
          setforumTopicsData,
          settotalRows,
          setTopicLoader
        )
      );
    }
  }, [createForumTopicResponseData, dispatch]);

  useEffect(() => {
    if (editForumTopicResponseData) {
      dispatch(
        getForumTopicsActionHandler(
          1,
          pageSize,
          setforumTopicsData,
          settotalRows,
          setTopicLoader
        )
      );
    }
  }, [editForumTopicResponseData, dispatch]);

  useEffect(() => {
    if (pageNum) {
      dispatch(
        getForumTopicsActionHandler(
          pageNum,
          pageSize,
          setforumTopicsData,
          settotalRows,
          setTopicLoader
        )
      );
    }
  }, [dispatch, pageNum, setforumTopicsData]);

  const fetchMoreData = () => {
    if (forumTopics?.length >= totalRows) {
      setHasMoreData(false);
      return;
    }
    setpageNum(pageNum + 1);
  };

  const editTopicClick = (topic) => {
    setCreateForumTopicModal(true);
    selectedTopic(topic);
    dispatch(setEditForumTopicResponse(null));
  };

  const forumTopicsClick = (id) => {
    setSelectedThread(null);
    setselectedTopicId(id);
    forumTopics?.forEach((data) => {
      if (data?.Id === id) {
        handleForumClick(data);
      }
    });
  };

  return (
    <div className={classes.discussionTopics}>
      <div className={classes.discussionTopicsHeading}>
        <div className={classes.discussionTopicsText}>
          <FormattedMessage id="FORUM_DISCUSSION_TOPIC" />
        </div>
        <div className={classes.totalDiscussionTopicText}>
          <FormattedMessage id="Report_Total" /> : {totalRows}
        </div>
      </div>
      <div className={classes.forumTopicList}>
        {forumTopics?.length > 0 && (
          <InfiniteScrollComponent
            dataLength={forumTopics?.length ? forumTopics.length : 10}
            fetchMoreData={fetchMoreData}
            hasMoreData={hasMoreData}
            height={"100vh"}
          >
            {forumTopics?.map((topic) => {
              return (
                <div
                  className={
                    selectedTopicId === topic.Id
                      ? classes.itemActive
                      : classes.item
                  }
                  key={topic.Id}
                  onClick={() => forumTopicsClick(topic?.Id)}
                >
                  <div className={classes.avatar}>
                    <img
                      className={classes.avatarImage}
                      src={topic?.TopicThumbnailUrl}
                      alt={topic.TopicName}
                      onError={(e) => {
                        e.target.onerror = null;
                        e.target.src = noTopicImage;
                      }}
                    />
                  </div>
                  <div className={classes.content}>
                    <div className={classes.titleDiv}>
                      <div className={classes.title}>
                        {/* {topic?.TopicName?.length > 60
                        ? topic?.TopicName?.slice(0, 60) + "..."
                        : topic?.TopicName} */}
                        {topic?.TopicName}
                      </div>
                      <div
                        style={{
                          paddingRight: "1rem",
                        }}
                        onClick={() => editTopicClick(topic)}
                      >
                        <EditIcon width="15.586" height="15.605" />
                      </div>
                    </div>
                    <div className={classes.topicDescription}>
                      {topic?.TopicDescription}
                    </div>
                    <div className={classes.footer}>
                      <span className={classes.footerDetails}>
                        {topic?.UserGroups?.length > 0 ? "Private" : "Public"}
                      </span>
                      <span className={classes.footerDetails}>
                        {topic.ForumThreadCount} Threads
                      </span>
                      <span className={classes.footerDetails}>
                        {topic.CreatedOn.slice(0, topic.CreatedOn.indexOf(" "))}
                      </span>
                      <span className={classes.footerDetails}>
                        {topic.CreatedOn.slice(
                          topic.CreatedOn.indexOf(" ") + 1,
                          topic.CreatedOn.length
                        )}
                      </span>
                    </div>
                  </div>
                </div>
              );
            })}
          </InfiniteScrollComponent>
        )}
        {forumTopics?.length === 0 && !topicLoader && (
          <div className={classes.noTopicsFound}> No Topics Found</div>
        )}
        {topicLoader && (
          <div className={classes.loader}>
            <Loader height="80%" width="10%" />
          </div>
        )}
      </div>
    </div>
  );
};

export default ForumTopics;
